import type { StepTarget } from 'react-joyride'

export function resolveStepElement(target: StepTarget): Element | null {
  if (typeof target === 'string') return document.querySelector(target)
  if (target instanceof HTMLElement) return target
  if (typeof target === 'function') return target()
  if (target && 'current' in target) return target.current

  return null
}

export function scrollTargetIntoHorizontalView(target: StepTarget): void {
  const element = resolveStepElement(target)

  if (
    !element ||
    element === document.body ||
    element === document.documentElement
  ) {
    return
  }

  element.scrollIntoView({ block: 'nearest', inline: 'center' })
}
